import urlJoin from 'url-join';
import { captureServerSessionId, getChatSessionId } from '../infrastructure/chatSessionId';
import { TenantId } from '../infrastructure/tenant';
import { ChatRequest, FeedbackRequest } from './types';

const getHeaders = (parameters: RequestParameters): Record<string, string> => ({
  'Content-Type': 'application/json',
  'X-Tenant': TenantId,
  'X-Chat-Session-Id': getChatSessionId(),
  ...(parameters.accessToken && { Authorization: `Bearer ${parameters.accessToken}` }),
});

const fetchWithSessionCapture = async (url: string, init: RequestInit): Promise<Response> => {
  const response = await fetch(url, init);
  captureServerSessionId(response);
  return response;
};

export async function postChatApi(
  request: ChatRequest,
  parameters: RequestParameters
): Promise<Response> {
  return await fetchWithSessionCapture(urlJoin(import.meta.env.VITE_API_URL || '', '/api/chat'), {
    method: 'POST',
    headers: getHeaders(parameters),
    body: JSON.stringify(request),
  });
}

export async function postFeedbackApi(
  request: FeedbackRequest,
  parameters: RequestParameters
): Promise<Response> {
  return await fetchWithSessionCapture(
    urlJoin(import.meta.env.VITE_API_URL || '', '/api/feedback'),
    {
      method: 'POST',
      headers: getHeaders(parameters),
      body: JSON.stringify(request),
    }
  );
}

export async function getUserInfo(parameters: RequestParameters): Promise<Response> {
  return await fetchWithSessionCapture(
    urlJoin(import.meta.env.VITE_API_URL || '', '/api/userinfo'),
    {
      method: 'GET',
      headers: getHeaders(parameters),
    }
  );
}

export async function getTranslation(parameters: RequestParameters): Promise<Response> {
  return await fetchWithSessionCapture(
    urlJoin(import.meta.env.VITE_API_URL || '', '/api/translation'),
    {
      method: 'GET',
      headers: getHeaders(parameters),
    }
  );
}

export interface RequestParameters {
  accessToken: string | undefined;
}
